import { Directive, HostListener, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputEffect]'
})
export class InputEffectDirective {
  element:any;

  @HostListener('ngModelChange', ['$event'])
  inputChanged(value: any) {

    if(typeof value == 'number') {
      value = JSON.stringify(value);
    }

    if(value && (value.length || typeof value=='object')) {
      // console.log(value);

      this.element.classList.add("fill");
      if(this.element.closest('.textarea')) {
        this.element.closest('.textarea').classList.add("fill");
      }
    } else {
      this.element.classList.remove("fill");
      if(this.element.closest('.textarea')) {
        this.element.closest('.textarea').classList.remove("fill");
      }
    }
  }

  @HostListener('input', ['$event'])
  removingcaracters(value: any) {
    // console.log(this.formControl.control);
    if (this.formControl) {
      if(this.formControl.control!.value) {
        if(typeof this.formControl.value === 'string') {
          if(this.formControl.control!.value.match(/['"´]/gi)) {
            this.formControl.control!.patchValue(this.formControl.control!.value.replaceAll(/['"´]/gi, ''));
          }
        }
      }
    }
  }

  constructor(@Optional() private formControl: NgControl, el: ElementRef, private ngControl:NgControl) {
    this.element = el.nativeElement;
  }

}
